export default __webpack_public_path__ + "static/media/mruLogo.796db31d.png";